import { Box, Grid } from "@material-ui/core";
import DeviceOrders from "../LiveDevice/DeviceOrders";
import { useEffect } from "react";
import Call from "../../service/API";
import useCustomState from "../../hooks/State";

const OrdersShow = ({ serial }) => {
  const deviceInfo = useCustomState({});
  const orderTypes = useCustomState([]);
  const deviceOrders = useCustomState([]);
  const orderPage = useCustomState(1);
  const updateOrderTable = () => {
    orderPage.handleChange(1);
    fetchDeviceOrders(serial, deviceOrders, 1);
  };
  const changeOrderPage = (page) => {
    orderPage.handleChange(page);
    fetchDeviceOrders(serial, deviceOrders, page);
  };
  useEffect(() => {
    fetchDeviceInfo(serial, deviceInfo);
    fetchOrderTypes(orderTypes);
    fetchDeviceOrders(serial, deviceOrders, orderPage.value);
  }, []);
  return (
    <>
      {deviceOrders.value.lenght > 0 ? (
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Grid
            container
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{
              background: "white",
              borderRadius: "8px",
              boxShadow: "0px 2px 2px 0px #444",
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
            }}
          >
            <DeviceOrders
              orderTypes={orderTypes.value}
              orders={deviceOrders.value}
              orderPage={orderPage.value}
              updateTable={updateOrderTable}
              deviceInfo={deviceInfo.value}
              changePage={changeOrderPage}
            />
          </Grid>
        </Box>
      ) : null}
    </>
  );
};
export default OrdersShow;
const fetchDeviceInfo = (deviceSerial, deviceInfo) => {
  const data = {
    water_meter_serial: deviceSerial,
  };
  Call("POST", "watermeters/admin/getOne", data)
    .then((response) => {
      if (response.data.code === 200) {
        deviceInfo.handleChange(response.data.data);
      }
    })
    .catch((error) => {
      if (error.response) {
      }
    });
};
const fetchOrderTypes = (orderTypes) => {
  const data = {
    page: 1,
    count: 100,
  };
  Call("POST", "OrderType/admin/getAll", data)
    .then((response) => {
      if (response.data.code === 200) {
        orderTypes.handleChange(response.data.data);
      }
    })
    .catch((error) => {
      if (error.response) {
      }
    });
};
const fetchDeviceOrders = (deviceSerial, deviceOrders, orderPage) => {
  const data = {
    page: orderPage,
    count: 10,
    order_meter: deviceSerial,
    order_type_id: null,
    order_type_code: null,
  };
  Call("POST", "Order/admin/getAll", data)
    .then((response) => {
      if (response.data.code === 200) {
        deviceOrders.handleChange(response.data.data);
      }
    })
    .catch((error) => {
      if (error.response) {
      }
    });
};
